import { Injectable, inject } from '@angular/core';
import { InputErrors } from '@shared/forms';
import { I18nService } from '@shared/i18n';

@Injectable({
  providedIn: 'root',
})
export class NomidioErrorsService {
  private readonly i18n = inject(I18nService);

  public textInputErrors(): InputErrors {
    return {
      email: this.i18n.getPhrase('nomidio.input.error.email'),
      exactlength: (error) => `${this.i18n.getPhrase('nomidio.input.error.exactlength')}${error.exactlength}`,
      forbidden: this.i18n.getPhrase('nomidio.input.error.forbidden'),
      min: (error) => `${this.i18n.getPhrase('nomidio.input.error.min')}${error.min}`,
      max: (error) => `${this.i18n.getPhrase('nomidio.input.error.max')}${error.max}`,
      minlength: (error) => `${this.i18n.getPhrase('nomidio.input.error.minlength')}${error.minlength}`,
      maxlength: (error) => `${this.i18n.getPhrase('nomidio.input.error.maxlength')}${error.maxlength}`,
      pattern: this.i18n.getPhrase('nomidio.input.error.pattern'),
      phone: this.i18n.getPhrase('nomidio.input.error.phone'),
      required: this.i18n.getPhrase('nomidio.input.error.required'),
      requiredTrue: this.i18n.getPhrase('nomidio.input.error.required'),
    };
  }

  public otpInputErrors(): InputErrors {
    return this.defaultsWith({
      required: this.i18n.getPhrase('nomidio.input.error.otp.required'),
      pattern: this.i18n.getPhrase('nomidio.input.error.otp.pattern'),
      exactlength: (error) => `${error.exactlength}${this.i18n.getPhrase('nomidio.input.error.otp.exactlength')}`,
      retry: this.i18n.getPhrase('nomidio.input.error.otp.retry'),
    });
  }

  private combine(...errors: InputErrors[]): InputErrors {
    return Object.assign({}, ...errors);
  }

  public defaultsWith(...errors: InputErrors[]): InputErrors {
    return this.combine(this.textInputErrors(), ...errors);
  }
}
